import { Option, Size } from 'components/Form/SelectCards/types';
import React from 'react';
import tw, { TwStyle } from 'twin.macro';

const SIZE_STYLES: Record<
  Size,
  {
    icon: TwStyle;
    container: TwStyle;
  }
> = {
  'extra-small': {
    icon: tw`size-4`,
    container: tw`h-5`,
  },
  small: {
    icon: tw`size-5`,
    container: tw`h-6`,
  },
  big: {
    icon: tw`size-5`,
    container: tw`h-6`,
  },
};
interface Props<T> {
  checked?: boolean;
  onChange: (checked: boolean) => void;
  size: Size;
  id: string;
  option: Option<T>;
  ariaLabel: string | undefined;
}
export function Radio<T>({
  checked,
  onChange,
  size,
  id,
  option,
  ariaLabel,
}: Props<T>) {
  const sizeStyles = SIZE_STYLES[size];
  const { description } = option;

  return (
    <div css={[tw`flex items-center relative`, sizeStyles.container]}>
      <input
        id={id}
        aria-label={ariaLabel}
        aria-describedby={description ? `${id}-description` : undefined}
        type="radio"
        role="radio"
        className="peer"
        tw="sr-only"
        checked={checked}
        onChange={() => onChange(!checked)}
      />

      <span
        css={[
          tw`flex items-center justify-center rounded-full border bg-white shrink-0 transition-shadow`,
          tw`peer-focus-visible:ring-2 peer-focus-visible:ring-brand-intense peer-focus-visible:ring-offset-2`,
          checked ? tw`border-brand-intense` : tw`border-neutral-moderate`,
          sizeStyles.icon,
        ]}
        aria-hidden
      >
        <span
          css={[
            tw`w-2.5 h-2.5 rounded-full`,
            checked ? tw`bg-brand-intense` : tw`bg-transparent`,
          ]}
        />
      </span>
    </div>
  );
}
